// Olya v3 confirmation state-machine formatter — mirrors the 5 branches
// produced by gonka_metrics/backend/core/services/confirmation_rate.py.
// Translates the structured `confirmation_rate` object into a tile-friendly
// display (value string, secondary state label key, optional tone).

import type { ConfirmationRate } from './minerApi.js';

export type ConfirmationTone = 'pos' | 'warn' | 'neg' | undefined;

export interface ConfirmationDisplay {
  readonly value: string | null;
  readonly subLabel: string | null;
  readonly tone: ConfirmationTone;
}

const KNOWN_STATES = new Set([
  'confirmed_by_cpoc',
  'epoch_baseline_or_accumulated_confirmation_weight',
  'inactive_no_chain_ratio',
  'missing_confirmation_data',
  'unknown',
]);

function stateKey(state: string): string {
  if (KNOWN_STATES.has(state)) {
    return `minerDetail.confirmationState.${state}`;
  }
  return 'minerDetail.confirmationState.unknown';
}

function formatPct(valuePct: number): string {
  return `${Math.round(valuePct)}%`;
}

export function formatConfirmationRate(
  rate: ConfirmationRate | undefined,
): ConfirmationDisplay {
  if (!rate) {
    return { value: null, subLabel: null, tone: undefined };
  }
  const subLabel = stateKey(rate.state);
  const value =
    rate.value_pct != null ? formatPct(rate.value_pct) : '—';

  let tone: ConfirmationTone;
  if (rate.state === 'confirmed_by_cpoc') {
    tone = 'pos';
  } else if (rate.state === 'epoch_baseline_or_accumulated_confirmation_weight') {
    tone = 'warn';
  } else {
    tone = undefined;
  }

  return { value, subLabel, tone };
}
